"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const parcel_1 = __importDefault(require("@becrop/components/Results/DistroTool/controllers/services/parcel"));
const vue_property_decorator_1 = require("vue-property-decorator");
let RecommendationFieldComponent = class RecommendationFieldComponent extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.fieldToSearch = '';
        this.fieldNamePreSelect = '';
        this.filteredFoundFields = [];
        this.fieldActiveKey = '';
    }
    changeKey() {
        if (this.fieldActiveKey !== this.fieldActiveKeyOut) {
            this.fieldActiveKey = this.fieldActiveKeyOut;
        }
    }
    changeProduct() {
        this.reactToProduct();
    }
    /*     @Watch('fields')
        updatedFields(){
                this.filteredFoundFields = this.fields.filter((f:any) => f.recommendations.some((r:any) => r.product.toUpperCase() === this.productRecommendationName.toUpperCase()))
        } */
    fieldStartLevel(field) {
        for (const recommendation of field.recommendations) {
            if (recommendation.product.toUpperCase() === this.productRecommendationName.toUpperCase()) {
                return recommendation.level;
            }
        }
    }
    parcelSvg(polygon) {
        return (0, parcel_1.default)(polygon, 30, 30);
    }
    emitFieldNamePreSelect(name) {
        this.fieldNamePreSelect === name ? this.fieldNamePreSelect = '' : this.fieldNamePreSelect = name;
        this.$emit('fieldNamePreSelect', this.fieldNamePreSelect);
    }
    onSearchField(f) {
        this.filteredFoundFields = this.filteredFoundFields.filter((fi) => fi.name.toLowerCase().includes(f.toLowerCase()));
        if (this.filteredFoundFields.length === 1) {
            this.emitFieldNamePreSelect(`${this.filteredFoundFields[0].name.toString()}${this.filteredFoundFields[0].id.toString()}`);
        }
    }
    updateFieldActiveKey(f) {
        this.$emit('updateFieldActiveKey', f);
        this.fieldActiveKey = f;
    }
    getFieldStyle(field) {
        let color = '#926fc0';
        return {
            stroke: color,
            fill: color + '50'
        };
    }
    reactToProduct() {
        const fieldsForProduct = this.fields.filter((f) => f.recommendations.some((r) => r.product.toUpperCase() === this.productRecommendationName.toUpperCase()));
        this.filteredFoundFields = fieldsForProduct;
    }
    mounted() {
        this.reactToProduct();
        this.changeKey();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], RecommendationFieldComponent.prototype, "fields", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], RecommendationFieldComponent.prototype, "productRecommendationName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '---' })
], RecommendationFieldComponent.prototype, "areaName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], RecommendationFieldComponent.prototype, "fieldActiveKeyOut", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fieldActiveKeyOut')
], RecommendationFieldComponent.prototype, "changeKey", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('productRecommendationName')
], RecommendationFieldComponent.prototype, "changeProduct", null);
RecommendationFieldComponent = __decorate([
    (0, vue_property_decorator_1.Options)({ components: { Rating: bmk_ui_framework_1.Rating, Search: bmk_ui_framework_1.Search } })
], RecommendationFieldComponent);
exports.default = RecommendationFieldComponent;
